import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/";
import { Checkbox } from "../../Checkbox";
import { NestedCheckboxes } from "./NestedCheckboxes";
import { convertPxToRem } from "../../../util-functions";
const SimpleCheckboxContainer = styled("div")({
    marginLeft: convertPxToRem(16),
    marginRight: convertPxToRem(16),
    // checkboxes
    "> div": {
        marginTop: convertPxToRem(10),
        marginBottom: convertPxToRem(10),
        width: "100%",
    },
});
export const CheckboxListMenuItem = ({ checkboxes, headers, selectableHeader = false, testId, variant = "simple", }) => (_jsxs("div", Object.assign({ "data-testid": testId }, { children: [variant === "simple" && (_jsx(SimpleCheckboxContainer, { children: checkboxes.map((checkbox) => {
                const { key, checked, label, value, onChange, testId: checkboxTestId, } = checkbox;
                return (_jsx(Checkbox, { testId: checkboxTestId, checked: checked, label: label, value: value, onChange: () => {
                        onChange(key, !checked);
                    } }, key));
            }) })), variant === "nested" && headers && (_jsx(_Fragment, { children: headers.map((header) => (_jsx(NestedCheckboxes, { header: header, checkboxes: checkboxes.filter((checkbox) => checkbox.key.toString().includes(header.key.toString())), selectableHeader: selectableHeader, testId: testId && `${testId}-${header.key}` }, header.key))) }))] })));
